import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import '../UserList/UserList.scss';
import './MedicalService.scss';
import '../Affiliates/Affiliates.scss';
import PropTypes from 'prop-types';
import icSearch from '../../../images/ic_search.png';
import actions from '../../../redux/actions';
import Loading from '../../../common/components/Loading/Loading';
import moment from 'moment';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Tooltip} from '@mui/material';
import Countdown from 'react-countdown';
import {useHistory} from 'react-router-dom';
import {CustomSelect} from '../../../common/components/CustomInputs/CustomInputs';
import {deleteExtraSpaces} from '../../../utils/util';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const MedicalService = (props) => {
    const {
        name,
        title,
        affiliates,
        getAffiliate,
        getAffiliatesState,
        attentionForCreate,
        setAffiliateSelected,
        switchOfUser,
        role,
        getBranches,
        branches,
        getBranchesProviders,
        branchesProviders,
        getBranchesState,
        getBranchesProvidersState,
        salesforceProviderId,
        cleanBranches,
        setAttentionForCreate,
        cleanGetAffiliatesState,
        cleanListConfig,
        userInfo,
        cleanAttentionsSelected,
        showSidebar,
    } = props;
    const history = useHistory();

    const [search, setSearch] = useState(affiliates && affiliates[0]?.documentNumber ? affiliates[0]?.documentNumber : '');
    const [firstView, setFirstView] = useState(true);
    const [searchTag, setSearchTag] = useState('document');
    const [branchesOptions, setBranchesOptions] = useState([]);
    const branchesProvidersOptions = useRef([]);
    const [provider, setProvider] = useState(attentionForCreate?.salesforceBranchId ?
        branchesProviders.find( ( branch ) => branch.branchId === attentionForCreate.salesforceBranchId)?.salesforceProviderId :
        null);
    const [branch, setBranch] = useState(attentionForCreate?.salesforceBranchId ?? null);

    useEffect(()=> {
        cleanBranches();
        if (role === 'ADMIN') {
            getBranches();
        } else if (role === 'PROVIDER_ADMIN') {
            setProvider(salesforceProviderId);
        }
        switchOfUser('Nueva atencion');
        cleanSearch();
        setFirstView(true);
        cleanListConfig('allMedicalServicesConfig');
        cleanAttentionsSelected();
        // eslint-disable-next-line
    }, []);

    useEffect( () => {
        setBranchesOptions(branches?.map((branch) => {
            if (branch.providerId === 'a1l2K000005fIfrQAE') {
                branch.fullName = 'Prestador sin sede';
            }
            return {value: branch.providerId.toString(), label: deleteExtraSpaces(branch.fullName)};
        }));
    }, [branches, getBranchesState.success]);

    useEffect(()=> {
        branchesProvidersOptions.current = branchesProviders?.map((branch) => {
            return {value: branch.branchId.toString(), label: branch.fullName};
        });
        setBranch(branchesProvidersOptions?.current[0]?.value);
    }, [branchesProviders, getBranchesProvidersState.success]);

    useEffect(()=>{
        if ((role === 'PROVIDER_ADMIN' || role === 'ADMIN') && provider) {
            getBranchesProviders(provider);
        }
        // eslint-disable-next-line
    }, [provider]);
    useEffect(()=>{
        if ((role === 'PROVIDER_ADMIN' || role === 'ADMIN') && branch) {
            setAttentionForCreate({salesforceBranchId: branch, salesforceProviderId: provider});
        } else {
            setAttentionForCreate({salesforceBranchId: userInfo.salesforceBranchId, salesforceProviderId: userInfo.salesforceProviderId});
        }
        // eslint-disable-next-line
    }, [branch]);

    moment.locale('es');

    const handleSearch = async () => {
        await getAffiliate(search, searchTag);
        setAffiliateSelected({
            searchTag: searchTag,
            affiliate: search,
        });
        setFirstView(false);
    };

    const tagNames = {
        document: 'Documento',
        affiliateNumber: 'Credencial',
    };

    const renderer = ({hours, minutes, seconds, completed}) => {
        if (!completed) {
            // Render a countdown
            return (
                <div className="countDownContainer">
                    <span className="countDown">Por favor intente nuevamente en: </span>
                    {minutes > 0 && <span className="countDown">{minutes + ' minuto' + (minutes > 1 ? 's, ' : ', ')}</span>}
                    <span className="countDown">{seconds} segundos</span>
                </div>);
        } else {
            cleanGetAffiliatesState();
            return null;
        }
    };

    const cleanSearch = () => {
        setFirstView(true);
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                </div>
                <div className="ul-div-form">
                    <div className="vu-form">
                        <div className="af-div-container">
                            {role === 'ADMIN' &&
                                <div className="branch-container">
                                    <div className="eu-div-input lbl-container">
                                        <text className="eu-text-l eu-f-label mb-05rem">Prestador</text>
                                        <CustomSelect
                                            name="provider"
                                            className="eu-input-l eu-select width-100"
                                            onChange={(value) => setProvider(value?.value)}
                                            value={ provider}
                                            options={branchesOptions}
                                            disabled={branchesOptions?.length === 0 || getBranchesState.loading}
                                            isSearchable={true}
                                        />
                                    </div>
                                    <div className="eu-div-input lbl-container">
                                        <text className="eu-text-s eu-f-label mb-05rem">Sede</text>
                                        <CustomSelect
                                            name="branch"
                                            className='eu-input-s eu-select width-100'
                                            onChange={(value)=>setBranch(value?.value)}
                                            value={ branch}
                                            options={branchesProvidersOptions.current}
                                            disabled={branchesProvidersOptions.current?.length === 0 || getBranchesProvidersState.loading}
                                            isSearchable={true}
                                        />
                                    </div>
                                </div>
                            }
                            {role === 'PROVIDER_ADMIN' &&
                                <div className="vu-row-data">
                                    <div className="eu-div-input">
                                        <text className="eu-text-l eu-f-label">Sede</text>
                                    </div>
                                    <div className="eu-div-input">
                                        <CustomSelect
                                            name="branch"
                                            className='eu-input-l eu-select'
                                            onChange={(value)=>setBranch(value?.value)}
                                            value={branch}
                                            options={branchesProvidersOptions.current}
                                            disabled={branchesProvidersOptions.current?.length === 0 || getBranchesProvidersState.loading}
                                            isSearchable={true}
                                        />
                                    </div>
                                </div>
                            }
                            <div>
                                <div className="eu-div-input">
                                    <text className="eu-text-l eu-f-label">Afiliado</text>
                                </div>
                                <div className="ul-div-searchAffiliates">
                                    <div className="ul-div-serchCont">
                                        <div className="ul-div-tagSel">
                                            <select
                                                className="ul-div-searchbar searchType"
                                                onChange={(e) => setSearchTag(e.target.value)}
                                                defaultValue={'name'}
                                            >
                                                <option value={'document'} selected="selected">{tagNames['document']}</option>
                                                <option value={'affiliateNumber'}>{tagNames['affiliateNumber']}</option>
                                            </select>
                                        </div>
                                        <div className="ul-div-searchbar">
                                            <input
                                                placeholder="Ingrese afiliado"
                                                value={search}
                                                onChange={(e) => {
                                                    setSearch(e.target.value.replace(/[^\w-/]/gi, ''));
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSearch();
                                                    }
                                                }}
                                            />
                                            <button onClick={() => handleSearch()}>
                                                <img src={icSearch} alt={'search'}/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="btn-container">
                                        {
                                            !firstView && !getAffiliatesState.loading && affiliates?.some((x) => x.status === 'Activo') &&
                                            <Ebutton classNameButton="ul-btn mr-btn" onClick={() => history.push('medicalServiceList')}
                                                                   disabled={(role === 'PROVIDER_ADMIN' || role === 'ADMIN') && !branch}
                                                                   text="Buscar prestación"/>
                                        }
                                        {
                                            search.length > 0 &&
                                                (<Ebutton
                                                    classNameButton="ul-btn"
                                                    onClick={() => handleSearch()}
                                                    text="Buscar afiliado"
                                                />)
                                        }
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {getAffiliatesState.success && affiliates ?
                    renderAffiliates(affiliates, cleanSearch, firstView, history, role, branch) :
                    getAffiliatesState.loading ?
                        <div className="mb-50">
                            {localStorage['affiliateRetry'] === '5' &&
                            <Countdown date={parseInt(localStorage['affiliateRetryTime'])} renderer={renderer}></Countdown>}
                            <Loading/>
                        </div> :
                        !firstView &&
                        <div className="ul-div-form vu-content">
                            <div className="vu-title column">
                                <text className="vu-name">Afiliado no encontrado</text>
                                {
                                    searchTag === 'document' && <text className="vu-subtext">Intente con número de afiliado</text>
                                }
                            </div>
                        </div>
                }
            </div>
        </div>
    );
};

const renderAffiliates = (affiliates, cleanSearch, firstView, history, role, branch) => {
    if (affiliates?.length === 0 && !firstView) {
        return (
            <div className="ul-div-form vu-content mb-50">
                <div className="vu-title">
                    <text className="vu-name">Afiliado no encontrado</text>
                    <text className="vu-row-data">Estado:
                        <Tooltip open={true} title={'Error, llamar a 08008883637'} placement="right">
                            <ClearIcon className='red-icon'/>
                        </Tooltip>
                    </text>
                </div>
            </div>
        );
    } else if (!firstView && affiliates[0].status !== 'Baja') {
        history.push('medicalServiceList');
    } else if (!firstView && affiliates[0].status === 'Baja') {
        return (
            <div>
                <div className="ul-div-form vu-content mb-50">
                    <div className="vu-title">
                        <text className="vu-name">{affiliates[0]?.fullName}</text>
                    </div>
                    <form className="vu-form">
                        <div className="vu-fm">
                            <div className="vu-div-container">
                                <div className="vu-row-data">
                                    <text>Tipo de documento: </text>
                                    <text>{affiliates[0]?.documentType}</text>
                                </div>
                                <div className="vu-row-data">
                                    <text>Número de documento: </text>
                                    <text>{affiliates[0]?.documentNumber}</text>
                                </div>
                                {affiliates[0].status === 'Baja' && !affiliates.filter((e)=> e.downDate !== affiliates[0].downDate).length > 0 &&
                                    <div className="vu-row-data">
                                        <text>Fecha de baja: {moment(affiliates[0].downDate).format('DD/MM/YYYY')}</text>
                                    </div>
                                }
                                <div className={affiliates.length === 1 ? '' : 'cards'}>
                                    {affiliates.map((affiliate, i) => (
                                        <div key={i} className="ul-div-form vu-content mb-50">
                                            <div className="vu-title">
                                                {affiliate?.status === 'Baja' &&
                                                <text className="vu-row-data">Estado:
                                                    <Tooltip open={true} title={affiliate?.status + ', llamar a 08008883637'} placement="right">
                                                        <ClearIcon className='red-icon'/>
                                                    </Tooltip>
                                                </text>}
                                                {affiliate?.status === 'Activo' && !affiliate?.dischargeDate &&
                                                <text className="vu-row-data">Estado:
                                                    <Tooltip title="Activo">
                                                        <CheckIcon className='green-icon'/>
                                                    </Tooltip>
                                                </text>}
                                                {affiliate?.status === 'Activo' && affiliate?.dischargeDate &&
                                                <text className="vu-row-data">Estado:
                                                    <Tooltip open={true} title={affiliate?.status + ', llamar a 08008883637'} placement="right">
                                                        <HelpOutlineIcon className='yellow-icon'/>
                                                    </Tooltip>
                                                </text>}
                                                {affiliate?.status !== 'Baja' && affiliate?.status !== 'Activo' &&
                                                <text className="vu-row-data">Estado:
                                                    <Tooltip open={true} title={affiliate?.status + ', llamar a 08008883637'} placement="right">
                                                        <WarningAmberIcon className='yellow-icon'/>
                                                    </Tooltip>
                                                </text>}
                                            </div>
                                            <form className="vu-form">
                                                <div className="vu-fm">
                                                    <div className="vu-div-container">
                                                        {affiliate?.dischargeDate && <div className="vu-row-data">
                                                            <text>Fecha de baja: </text>
                                                            <text>{moment(affiliate?.dischargeDate).format('DD/MM/YYYY')}</text>
                                                        </div>}
                                                        <div className="vu-row-data">
                                                            <text>Credencial: </text>
                                                            <text>{affiliate?.affiliateNumber}</text>
                                                        </div>
                                                        <div className="vu-row-data">
                                                            <text>{affiliate?.plans?.length > 1 ? 'Planes: ' : 'Plan: '}</text>
                                                            <ul>
                                                            {
                                                                    affiliate?.plans?.map((plan, index) => (
                                                                        <li key={index}>
                                                                            {affiliate.status === 'Baja' ?
                                                                            <>
                                                                            {plan.name} | Fecha de baja: {moment(affiliate.downDate).format('DD/MM/YYYY')}
                                                                            </> :
                                                                            <>
                                                                            {plan.name} | Fecha de alta: {moment(plan.createdAt).format('DD/MM/YYYY')}
                                                                            </>
                                                                        }
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    affiliates: state.home.affiliates,
    attentionForCreate: state.home.attentionForCreate,
    getAffiliatesState: state.home.getAffiliatesState,
    role: state.login.userInfo.role.name,
    userInfo: state.login.userInfo,
    salesforceProviderId: state.login.userInfo.salesforceProviderId,
    branches: state.home.branches,
    branchesProviders: state.home.branchesProviders,
    getBranchesState: state.home.getBranchesState,
    getBranchesProvidersState: state.home.getBranchesProvidersState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getAffiliate: (document, type) => dispatch(actions.home.getAffiliateRequest(document, type)),
    cleanAffiliates: () => dispatch(actions.home.cleanAffiliates()),
    setAffiliateSelected: (affiliate) => dispatch(actions.home.setAffiliateSelected(affiliate)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getBranches: () => dispatch(actions.home.getBranchesRequest()),
    getBranchesProviders: (id) => dispatch(actions.home.getBranchesProvidersRequest(id)),
    cleanBranches: () => dispatch(actions.home.cleanBranches()),
    cleanProvidersBranches: () => dispatch(actions.home.cleanProvidersBranches()),
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    cleanGetAffiliatesState: () => dispatch(actions.home.cleanGetAffiliatesState()),
    cleanListConfig: (list) => dispatch( actions.home.cleanListConfig(list) ),
    cleanAttentionsSelected: () => dispatch(actions.home.cleanAttentionsSelected()),
});

MedicalService.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    affiliates: PropTypes.object,
    getAffiliatesState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalService);

